import script from "./AddressAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressAutocomplete.vue?vue&type=script&setup=true&lang=js"

import "./AddressAutocomplete.vue?vue&type=style&index=0&id=049db757&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049db757"]])

export default __exports__